import { createAction, createReducer } from '@reduxjs/toolkit';

export const showOnboarding = createAction('onboarding/show');
export const hideOnboarding = createAction('onboarding/hide');
export const nextStep = createAction('onboarding/nextStep');
export const previousStep = createAction('onboarding/previousStep');
export const goToStep = createAction('onboarding/goToStep', (stepNumber) => ({
  payload: { stepNumber }
}));
export const completeStep = createAction('onboarding/completeStep', (stepNumber) => ({
  payload: { stepNumber }
}));
export const resetOnboarding = createAction('onboarding/reset');
export const setOnboardingData = createAction('onboarding/setData', (data) => ({
  payload: data
}));

const initialState = {
  isVisible: false,
  currentStep: 1,
  totalSteps: 3,
  completedSteps: [],
  isComplete: false,
  userData: {
    userId: null,
    email: null,
    sessionId: null,
    userType: 'anonymous'
  },
  steps: [
    {
      id: 1,
      key: 'welcome',
      title: 'Guarda todas tus maquetas en un mismo lugar',
      description: 'Organiza y gestiona todos tus proyectos musicales desde una plataforma centralizada',
      completed: false
    },
    {
      id: 2,
      key: 'features',
      title: 'Asigna Roles a los participantes de tu proyecto',
      description: 'Colabora eficientemente definiendo permisos y responsabilidades para cada miembro',
      completed: false
    },
    {
      id: 3,
      key: 'getStarted',
      title: 'Comparte tu música de la forma que más te guste',
      description: 'Distribuye y promociona tu música en múltiples plataformas de manera sencilla',
      completed: false
    }
  ]
};

const onboardingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(showOnboarding, (state) => {
      state.isVisible = true;
      state.currentStep = 1;
    })
    .addCase(hideOnboarding, (state) => {
      state.isVisible = false;
    })
    .addCase(nextStep, (state) => {
      if (state.currentStep < state.totalSteps) {
        state.currentStep += 1;
      }
    })
    .addCase(previousStep, (state) => {
      if (state.currentStep > 1) {
        state.currentStep -= 1;
      }
    })
    .addCase(goToStep, (state, action) => {
      const { stepNumber } = action.payload;
      if (stepNumber >= 1 && stepNumber <= state.totalSteps) {
        state.currentStep = stepNumber;
      }
    })
    .addCase(completeStep, (state, action) => {
      const { stepNumber } = action.payload;
      if (!state.completedSteps.includes(stepNumber)) {
        state.completedSteps.push(stepNumber);
      }
      
      const stepIndex = state.steps.findIndex(step => step.id === stepNumber);
      if (stepIndex !== -1) {
        state.steps[stepIndex].completed = true;
      }
      
      if (state.completedSteps.length === state.totalSteps) {
        state.isComplete = true;
      }
    })
    .addCase(resetOnboarding, (state) => {
      state.currentStep = 1;
      state.completedSteps = [];
      state.isComplete = false;
      state.steps.forEach(step => {
        step.completed = false;
      });
    })
    .addCase(setOnboardingData, (state, action) => {
      const { userId, email, sessionId, userType } = action.payload;
      state.userData = {
        userId: userId || null,
        email: email || null,
        sessionId: sessionId || null,
        userType: userType || 'anonymous'
      };
    });
});

export { onboardingReducer };